import React from 'react'
import './index.scss'
import PaginationComponent from '@Components/Tables/Pagination'
import { PaginationBody } from '@Entities/pagination'
import PaginationResultsBlock from '@Components/Navigations/PaginationResultsBlock'
import { getNumTitles } from '@App/helpers/pagination/get-num-titles'
import { ZodFormattedError } from 'zod'
import { calcNumPages } from '@App/helpers/pagination/calc-num-pages'
import RecordingsTableRow from '@Components/ViewWork/RecordingsTable/RecordingsTableRow'
import { RecordingModel } from '@Entities/work/recording-model'

interface RecordingsTableProps {
    recordings: RecordingModel[]
    errors?: ZodFormattedError<RecordingModel[]>
    totalRecordings: number
    currentPage: number
    handlePage: (pagination: PaginationBody) => void
    recordingType: 'matched' | 'registration'
    editing?: boolean
}

const RecordingsTable = ({
    recordings,
    errors,
    totalRecordings,
    currentPage,
    handlePage,
    recordingType,
    editing,
}: RecordingsTableProps) => {
    const PAGE_LIMIT = 10

    const paginationInfo = calcNumPages(totalRecordings, PAGE_LIMIT, currentPage)
    const numTitles = getNumTitles(totalRecordings, paginationInfo.currentPage, PAGE_LIMIT)

    return (
        <>
            {recordings.length ? (
                <>
                    <PaginationResultsBlock workNumTitles={numTitles} totalResults={totalRecordings} />
                    <table className="recordings-table">
                        <thead>
                            <tr>
                                <th>
                                    <div>Recording Artist</div>
                                </th>
                                <th>
                                    <div>Recording Title</div>
                                </th>
                                <th>
                                    <div>ISRC</div>
                                </th>
                                <th>{recordingType === 'matched' ? <div>DSP</div> : <div>Release Date</div>}</th>
                                <th>
                                    <div>Label</div>
                                </th>
                                <th>
                                    <div>Duration</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {recordings.map((rec, idx) => (
                                <RecordingsTableRow
                                    key={idx}
                                    recording={rec}
                                    recordingType={recordingType}
                                    error={errors?.[idx]}
                                />
                            ))}
                        </tbody>
                    </table>
                    {totalRecordings > PAGE_LIMIT && (
                        <PaginationComponent
                            limit={PAGE_LIMIT}
                            paginationPages={paginationInfo}
                            onChange={handlePage}
                        />
                    )}
                </>
            ) : (
                <div className="missing-records">{`No recordings ${!editing ? 'found' : ''}`}</div>
            )}
        </>
    )
}

export default RecordingsTable
